/*
 * Grocera – ca aplicația (a șaptea rundă, 04.10.2026): „Date personale” și „Adresele de livrare” pe site, ca în
 * aplicație (grocera-app, src/screens/profile-screen.tsx și addresses-screen.tsx). Zoli: „dacă dau pe adresele de
 * livrare tot în meniul vechi mă bagă, și la date personale și peste tot, ți-am zis trebuie să fie ca în APK”.
 *
 * - Date personale (/?view=date, sections/grocera-date.liquid): prenumele și numele, „Salvează” activ doar când s-a
 *   schimbat ceva; salvarea merge la grocera-routes (/apps/urmarire/cont, `fapta: nume`), apoi înapoi la „Contul meu”.
 * - Adresele de livrare (/?view=adrese, sections/grocera-adrese.liquid): adresele din cont (/apps/urmarire/adrese, cel
 *   mult trei, aceleași ca în coș și în aplicație), cu „Folosită acum”, „Modifică”, „Șterge” și „Adaugă o adresă”.
 *   Adăugarea și modificarea deschid formularul widgetului de livrare (window.GroceraLivrare.formularAdresa), ca
 *   adresa să fie verificată pe hartă; „înapoi” (bara de sus sau gestul telefonului) închide formularul.
 * - Credit în cont (/?view=credit, sections/grocera-credit.liquid; 05.10.2026, Zoli: „fă să fie și în web cum era în
 *   app”): soldul din Liquid, ce expiră și istoricul de la grocera-routes (/apps/urmarire/credit), ca credit-screen.tsx.
 * Clientul îl pune Shopify în cererile prin App Proxy (semnat); pagina nu trimite niciodată un id de client.
 */
(function () {
  'use strict';

  var BAZA = '/apps/urmarire';
  var box = document.querySelector('[data-gp]');
  if (!box) return;
  var CONT = box.getAttribute('data-gp-cont') || '/?view=cont';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function esc(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function icon(id, extraClass) {
    return '<svg' + (extraClass ? ' class="' + extraClass + '"' : '') + ' aria-hidden="true" focusable="false"><use href="#' + id + '"></use></svg>';
  }

  /** Un formular spre grocera-routes, prin App Proxy (Shopify adaugă clientul logat și semnează cererea). */
  function post(path, fields) {
    var body = new FormData();
    Object.keys(fields).forEach(function (key) {
      body.append(key, fields[key] == null ? '' : String(fields[key]));
    });
    return fetch(BAZA + path, { method: 'POST', body: body, credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
      function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      },
    );
  }

  /** Ca în aplicație, după salvare: înapoi la „Contul meu”, care se redesenează cu numele nou. */
  function backToAccount() {
    var fromAccount = false;
    try {
      var ref = new URL(document.referrer);
      fromAccount = ref.origin === location.origin && /(^|[?&])view=cont(&|$)/.test(ref.search.slice(1));
    } catch (error) {
      fromAccount = false;
    }
    try {
      sessionStorage.setItem('ga-cont-reincarca', '1');
    } catch (error) {}
    if (fromAccount && history.length > 1) history.back();
    else location.href = CONT;
  }

  /* ───────── Date personale ───────── */

  function datePage() {
    var form = box.querySelector('[data-gp-nume]');
    if (!form) return;
    var inputs = form.querySelectorAll('input[name]');
    var button = form.querySelector('[data-gp-salveaza]');
    var message = form.querySelector('[data-gp-mesaj]');
    var busy = false;

    function clean(value) {
      return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
    }
    function changed() {
      var any = false;
      each(inputs, function (input) {
        if (clean(input.value) !== clean(input.getAttribute('data-initial'))) any = true;
      });
      return any;
    }
    function refresh() {
      button.disabled = busy || !changed();
    }
    function say(text, isError) {
      message.hidden = !text;
      message.textContent = text || '';
      message.classList.toggle('is-eroare', !!isError);
    }

    each(inputs, function (input) {
      input.addEventListener('input', function () {
        say('');
        refresh();
      });
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy || !changed()) return;
      busy = true;
      button.classList.add('is-busy');
      button.textContent = 'Se salvează…';
      refresh();
      var first = clean(form.elements.prenume.value);
      var last = clean(form.elements.numeFamilie.value);
      post('/cont', { fapta: 'nume', prenume: first, numeFamilie: last })
        .then(function (r) {
          if (r && r.stare === 'oaspete') {
            say('Intră din nou în cont ca să salvezi.', true);
            return;
          }
          if (!r || r.stare !== 'ok') throw new Error((r && r.mesaj) || 'eroare');
          form.elements.prenume.value = r.prenume != null ? r.prenume : first;
          form.elements.numeFamilie.value = r.numeFamilie != null ? r.numeFamilie : last;
          each(inputs, function (input) {
            input.setAttribute('data-initial', clean(input.value));
          });
          say('Am salvat.');
          setTimeout(backToAccount, 500);
        })
        .catch(function (error) {
          say(withErrorCode('cont.date', 'Nu am putut salva. Încearcă din nou.', null, error), true);
        })
        .then(function () {
          busy = false;
          button.classList.remove('is-busy');
          button.textContent = 'Salvează';
          refresh();
        });
    });
    refresh();
  }

  /* ───────── Adresele de livrare ───────── */

  var KEY_CURRENT = 'grocera.livrare.adresa';
  var MAX = 3;

  function currentId() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY_CURRENT) || 'null');
      return a && a.idSalvat ? String(a.idSalvat) : null;
    } catch (error) {
      return null;
    }
  }

  /** Telefonul, ca în aplicație: 0740 123 456. */
  function phone(text) {
    var digits = String(text == null ? '' : text).replace(/[\s.\-()]/g, '');
    if (/^\+40\d{9}$/.test(digits)) digits = '0' + digits.slice(3);
    if (/^0\d{9}$/.test(digits)) return digits.slice(0, 4) + ' ' + digits.slice(4, 7) + ' ' + digits.slice(7);
    return String(text == null ? '' : text).trim();
  }

  function labelIcon(label) {
    if (/^acas[aă]$/i.test(String(label || '').trim())) return 'gp-i-acasa';
    if (/^birou$/i.test(String(label || '').trim())) return 'gp-i-birou';
    return 'gp-i-pin';
  }

  function streetLine(a) {
    var street = String(a.strada || '').trim();
    if (!street) return String(a.adresa || '').trim();
    var line = street + (a.numar ? ' ' + String(a.numar).trim() : '');
    return a.oras ? line + ', ' + a.oras : line;
  }

  function card(a, inUse) {
    var details = [a.etaj ? 'Etaj ' + a.etaj : '', a.ap ? 'Ap. ' + a.ap : '', a.pin ? 'Interfon ' + a.pin : ''].filter(Boolean);
    var person = [String(a.prenume || '').trim(), String(a.numeFamilie || '').trim()].filter(Boolean).join(' ');
    var contact = [person, phone(a.telefon)].filter(Boolean);
    var label = String(a.eticheta || 'Adresa mea');
    var id = esc(a.id);
    return (
      '<div class="gp-adresa" data-gp-id="' + id + '">' +
      '<button type="button" class="gp-adresa__corp" data-gp-modifica="' + id + '" aria-label="' + esc(label + ': ' + streetLine(a)) + '. Modifică adresa">' +
      '<span class="gp-adresa__cap">' + icon(labelIcon(label), 'gp-adresa__ic') +
      '<span class="gp-adresa__eticheta">' + esc(label + (a.implicita ? ' ★' : '')) + '</span>' +
      (inUse ? '<span class="gp-adresa__acum">Folosită acum</span>' : '') +
      '</span>' +
      '<span class="gp-adresa__strada">' + esc(streetLine(a)) + '</span>' +
      (details.length ? '<span class="gp-adresa__meta">' + esc(details.join(' · ')) + '</span>' : '') +
      (contact.length ? '<span class="gp-adresa__meta">' + esc(contact.join(' · ')) + '</span>' : '') +
      '</button>' +
      '<div class="gp-adresa__actiuni">' +
      '<button type="button" class="gp-adresa__actiune" data-gp-modifica="' + id + '">' + icon('gp-i-creion') + 'Modifică</button>' +
      '<span class="gp-adresa__sep" aria-hidden="true"></span>' +
      '<button type="button" class="gp-adresa__actiune gp-adresa__actiune--pericol" data-gp-sterge="' + id + '">' + icon('gp-i-cos') + 'Șterge</button>' +
      '</div>' +
      '</div>'
    );
  }

  function addressesPage() {
    var list = box.querySelector('[data-gp-adrese]');
    var formBox = box.querySelector('[data-gp-formular]');
    if (!list || !formBox) return;
    var barTitle = document.querySelector('#GaTopbar [data-gp-bara]');
    var pageTitle = box.querySelector('[data-gp-titlu]');
    var upText = box.querySelector('[data-gp-sus-text]');
    // `error`: `false` sau rândul „Cod …” al căderii (codurile de eroare, 08.10.2026).
    var state = { items: [], error: false, notice: null, formOpen: false };
    var ignorePop = false;

    function setTitle(text, inForm) {
      if (barTitle) barTitle.textContent = text;
      if (pageTitle) pageTitle.textContent = text;
      if (upText) upText.textContent = inForm ? 'Adresele de livrare' : 'Contul meu';
    }

    function render() {
      list.removeAttribute('aria-busy');
      var html = '';
      if (state.notice) {
        html += '<p class="gp-anunt' + (state.notice.error ? ' is-eroare' : '') + '" role="status">' + esc(state.notice.text) + '</p>';
      }
      if (state.error) {
        html +=
          '<div class="gp-gol">' + icon('gp-i-locatie', 'gp-gol__ic') +
          '<p class="gp-gol__titlu">Nu am putut încărca adresele</p>' +
          '<p class="gp-gol__text">Verifică internetul și încearcă din nou.</p>' +
          (typeof state.error === 'string' ? state.error : '') +
          '<button type="button" class="gp-buton" data-gp-reincearca>Încearcă din nou</button></div>';
      } else if (!state.items.length) {
        html +=
          '<div class="gp-gol">' + icon('gp-i-locatie', 'gp-gol__ic') +
          '<p class="gp-gol__titlu">Nicio adresă salvată</p>' +
          '<p class="gp-gol__text">Adaugă adresa o dată și o alegi dintr-o apăsare la fiecare comandă.</p>' +
          '<button type="button" class="gp-buton" data-gp-adauga>Adaugă o adresă</button></div>';
      } else {
        var current = currentId();
        state.items.forEach(function (a) {
          html += card(a, current != null && String(a.id) === current);
        });
        if (state.items.length < MAX) {
          html += '<button type="button" class="gp-buton gp-buton--secundar" data-gp-adauga>' + icon('gp-i-plus') + 'Adaugă o adresă</button>';
        } else {
          html += '<p class="gp-limita">Poți salva cel mult ' + MAX + ' adrese. Șterge una ca să adaugi alta.</p>';
        }
      }
      list.innerHTML = html;
    }

    function load() {
      return fetch(BAZA + '/adrese', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (r) {
          state.error = false;
          state.items = (r && r.adrese) || [];
        })
        .catch(function (error) {
          state.error = codeLine('livrare.adrese-citire', 'Nu am putut încărca adresele', null, error) || true;
        })
        .then(render);
    }

    function find(id) {
      for (var i = 0; i < state.items.length; i++) if (String(state.items[i].id) === String(id)) return state.items[i];
      return null;
    }

    function openForm(item) {
      var api = window.GroceraLivrare && window.GroceraLivrare.formularAdresa;
      if (typeof api !== 'function') {
        state.notice = { text: 'Deocamdată adresele se adaugă și se modifică din coș, la „Când livrăm?”.', error: true };
        render();
        return;
      }
      state.formOpen = true;
      state.notice = null;
      var title = item ? 'Modifică adresa' : 'Adresă nouă';
      list.hidden = true;
      formBox.hidden = false;
      // Titlul („Adresă nouă” / „Modifică adresa”) e în bara de sus pe telefon și deasupra, mare, pe calculator.
      formBox.innerHTML =
        '<div data-gp-widget></div><button type="button" class="gp-formular__renunta" data-gp-renunta>Renunță</button>';
      setTitle(title, true);
      try {
        history.pushState({ gpFormular: 1 }, '');
      } catch (error) {}
      api(formBox.querySelector('[data-gp-widget]'), {
        adresa: item || null,
        laTerminare: function (saved, problem) {
          closeForm(true, problem || '');
        },
      });
      window.scrollTo(0, 0);
    }

    function closeForm(saved, problem) {
      if (!state.formOpen) return;
      state.formOpen = false;
      formBox.hidden = true;
      formBox.innerHTML = '';
      list.hidden = false;
      setTitle('Adresele de livrare', false);
      if (history.state && history.state.gpFormular) {
        ignorePop = true;
        history.back();
      }
      if (saved) {
        state.notice = problem ? { text: problem, error: true } : { text: 'Am salvat adresa.' };
        load();
      } else {
        render();
      }
      window.scrollTo(0, 0);
    }

    function remove(item, node) {
      var text = (item.eticheta || 'Adresa mea') + ': ' + streetLine(item);
      if (!window.confirm('Ștergi adresa?\n' + text)) return;
      if (node) node.classList.add('is-busy');
      post('/adrese', { fapta: 'sterge', id: item.id })
        .then(function (r) {
          if (!r || r.eroare || (r.stare && r.stare !== 'ok')) throw new Error('sterge');
          state.items = state.items.filter(function (a) {
            return String(a.id) !== String(item.id);
          });
          state.notice = { text: 'Am șters adresa.' };
          render();
        })
        .catch(function (error) {
          state.notice = {
            text: withErrorCode('livrare.adresa-stergere', 'Nu am putut șterge adresa. Încearcă din nou.', null, error),
            error: true,
          };
          render();
        });
    }

    list.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-gp-modifica], [data-gp-sterge], [data-gp-adauga], [data-gp-reincearca]');
      if (!target) return;
      event.preventDefault();
      if (target.hasAttribute('data-gp-adauga')) openForm(null);
      else if (target.hasAttribute('data-gp-reincearca')) {
        list.setAttribute('aria-busy', 'true');
        load();
      } else if (target.hasAttribute('data-gp-modifica')) {
        var item = find(target.getAttribute('data-gp-modifica'));
        if (item) openForm(item);
      } else {
        var gone = find(target.getAttribute('data-gp-sterge'));
        if (gone) remove(gone, target.closest('.gp-adresa'));
      }
    });
    formBox.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-gp-renunta]')) {
        event.preventDefault();
        closeForm(false);
      }
    });
    // Cât e deschis formularul, „înapoi” (bara de sus, „‹” de pe calculator) îl închide, ca în aplicație.
    document.addEventListener(
      'click',
      function (event) {
        if (!state.formOpen) return;
        var back = event.target.closest && event.target.closest('[data-ga-back], [data-gp-sus]');
        if (!back) return;
        event.preventDefault();
        event.stopPropagation();
        closeForm(false);
      },
      true,
    );
    window.addEventListener('popstate', function () {
      if (ignorePop) {
        ignorePop = false;
        return;
      }
      if (state.formOpen) closeForm(false);
    });

    load();
  }

  /* ───────────── „Credit în cont” ───────────── */

  var LUNI = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
  var ETICHETE = { credit: 'Credit primit', debit: 'Folosit la o comandă', expiration: 'Expirat', revert: 'Înapoi în cont' };

  /** Ca formatBani din aplicație: 1250 → „12,50 RON”. */
  function lei(bani) {
    return (Math.round(Number(bani) || 0) / 100).toFixed(2).replace('.', ',') + ' RON';
  }

  /** [an, lună, zi] la ora României. */
  function ziua(date) {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit' })
        .format(date)
        .split('-')
        .map(Number);
    } catch (error) {
      return [date.getFullYear(), date.getMonth() + 1, date.getDate()];
    }
  }

  /** Ca shortDate din aplicație: „30 noiembrie”, cu anul doar când nu e anul acesta. */
  function dataScurta(iso) {
    var date = new Date(iso);
    if (isNaN(date.getTime())) return '';
    var z = ziua(date);
    return z[2] + ' ' + LUNI[z[1] - 1] + (z[0] === ziua(new Date())[0] ? '' : ' ' + z[0]);
  }

  /**
   * Soldul îl scrie Liquid (customer.store_credit_account); ce expiră și istoricul vin de la grocera-routes
   * (GET /apps/urmarire/credit), din Admin API, ca în aplicație. Pe un server fără ruta asta, App Proxy-ul dă o
   * pagină HTML: pagina rămâne doar cu soldul, fără istoric și fără eroare.
   */
  function creditPage() {
    var history = box.querySelector('[data-gp-istoric]');
    var balance = box.querySelector('[data-gp-sold]');
    var expiring = box.querySelector('[data-gp-expira]');
    var expiringText = box.querySelector('[data-gp-expira-text]');
    if (!history) return;

    function row(t) {
      var plus = t.tip === 'credit' || t.tip === 'revert';
      var meta = dataScurta(t.data) + (t.tip === 'credit' && t.expira ? ' · expiră pe ' + dataScurta(t.expira) : '');
      return (
        '<div class="gp-tranz' + (plus ? ' gp-tranz--plus' : '') + '">' +
        '<span class="gp-tranz__ic">' + icon(plus ? 'gp-i-plus' : 'gp-i-minus') + '</span>' +
        '<span class="gp-tranz__text"><span class="gp-tranz__titlu">' + esc(ETICHETE[t.tip] || ETICHETE.credit) + '</span>' +
        '<span class="gp-tranz__meta">' + esc(meta) + '</span></span>' +
        '<span class="gp-tranz__suma">' + (plus ? '+' : '−') + esc(lei(t.bani)) + '</span>' +
        '</div>'
      );
    }

    function show(credit) {
      // Soldul de acum (dacă între timp s-a folosit sau s-a primit credit, după ce Liquid a scris pagina).
      if (balance && typeof credit.soldBani === 'number') balance.textContent = lei(credit.soldBani);
      if (expiring && expiringText && credit.expira && credit.expira.bani > 0) {
        expiringText.textContent = lei(credit.expira.bani) + ' expiră pe ' + dataScurta(credit.expira.data);
        expiring.hidden = false;
      } else if (expiring) {
        expiring.hidden = true;
      }
      var list = Array.isArray(credit.tranzactii) ? credit.tranzactii : [];
      history.innerHTML = list.length
        ? '<h2 class="gp-istoric__titlu">Istoric</h2>' + list.map(row).join('')
        : '<p class="gp-istoric__stare">Încă n-ai primit credit. Îl primești, de exemplu, pentru ambalajele SGR returnate curierului.</p>';
    }

    function failed(error) {
      history.innerHTML =
        '<p class="gp-istoric__stare">Nu am putut încărca istoricul.</p>' +
        codeLine(
          'cont.credit',
          'Nu am putut încărca istoricul.',
          error instanceof Error ? null : { raspuns: error && error.stare ? error.stare : null },
          error instanceof Error ? error : null,
        ) +
        '<button type="button" class="gp-buton gp-buton--secundar" data-gp-reincearca>Încearcă din nou</button>';
    }

    function load() {
      history.hidden = false;
      history.innerHTML = '<p class="gp-istoric__stare">Se încarcă istoricul…</p>';
      fetch(BAZA + '/credit', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (body) {
          // Fără ruta pe server, App Proxy-ul dă o pagină a magazinului (chiar cu `application/json` în antet, văzut pe
          // 05.10): nu e un răspuns de-al nostru, deci rămâne doar soldul.
          try {
            return JSON.parse(body);
          } catch (error) {
            return { stare: 'fara-ruta' };
          }
        })
        .then(function (data) {
          if (data && data.stare === 'ok' && data.credit) return show(data.credit);
          if (data && data.stare === 'fara-ruta') {
            history.innerHTML = '';
            history.hidden = true;
            return;
          }
          failed(data);
        })
        .catch(failed);
    }

    history.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-gp-reincearca]')) load();
    });
    load();
  }

  /*
   * Codurile de eroare (08.10.2026): cazul pleacă în jurnalul nostru (`grocera-erori.js`, din embed-ul „Grocera ·
   * livrare”), iar omul vede „Cod 4003-58319”. Fără el, doar mesajul, ca înainte.
   */
  function errorCase(key, text, details, error) {
    var E = window.GroceraErori;
    if (!E || typeof E.raporteaza !== 'function') return null;
    try {
      return E.raporteaza(key, { mesaj: text, detalii: details || null, eroare: error || null });
    } catch (x) {
      return null;
    }
  }

  /** „mesaj (Cod …)”, pentru un rând de text. */
  function withErrorCode(key, text, details, error) {
    var c = errorCase(key, text, details, error);
    return c ? window.GroceraErori.text(c) : text;
  }

  /** Rândul „Cod …” sub un mesaj de eroare din pagină (HTML). */
  function codeLine(key, text, details, error) {
    var c = errorCase(key, text, details, error);
    return c ? '<p class="gp-cod">' + esc(c.eticheta) + '</p>' : '';
  }

  var kind = box.getAttribute('data-gp');
  if (kind === 'date') datePage();
  else if (kind === 'adrese' && box.hasAttribute('data-gp-logat')) addressesPage();
  else if (kind === 'credit' && box.hasAttribute('data-gp-logat')) creditPage();
})();
